import {
  Box,
  Button,
  Divider,
  OutlinedInput,
  InputLabel,
  IconButton,
  InputAdornment,
  FormControl,
  FormHelperText,
  Grid,
  Select,
  MenuItem,
} from "@mui/material";
import { useCallback, useEffect, useState, useRef } from "react";
import { Controller, useForm, FormProvider } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useHistory } from "react-router-dom";
import { loadAction } from "redux/reducers/top";
import Email from "components/ui/join/email";
import AlertConfirm from "components/ui/alert-confirm";
import AlertComplete from "components/ui/alert-complete";
import axios from "axios";
import DrawerTimer from "components/ui/drawer-timer";
import DrawerComplete from "components/ui/drawer-complete";

import { Cookies } from "react-cookie";
import jwt_decode from "jwt-decode";
import { refreshToken } from "assets/js/common";
import { setUserInfoAction } from "redux/reducers/user";

const cookies = new Cookies();

export default function EmailPage() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [open, setOpen] = useState(false);
  const [openComp, setOpenComp] = useState(false);
  const [userInfo, setUserInfo] = useState("");

  const form = useForm({
    defaultValues: {
      no: "",
      email: "", // 이메일
      emailAddr: "",
      emailStr: "",
    },
  });

  const handleAlertClose = () => {
    setOpen(false);
  };

  const updateUserInfo = async () => {
    let myDecodedToken = await refreshToken();
    dispatch(setUserInfoAction(myDecodedToken));
    setOpenComp(true);
  };

  const getEmail = (data) => {
    let result = "";
    if (data.email) {
      result = `${data.email}@${
        data.emailStr ? data.emailStr : data.emailAddr
      }`;
    }
    return result;
  };
  const onSubmit = async (data) => {
    let form = {
      no: userInfo && userInfo.no,
      email: getEmail(data),
    };

    await axios.post("/api/mb/member/modify", form).then((res) => {
      if (res.data.data) {
        updateUserInfo();
      }
    });
  };

  const handleCancel = () => {};

  const { init } = useSelector((state) => state.top);
  useEffect(() => {
    if (init)
      dispatch(loadAction({ back: true, title: "개인정보 수정", menu: false }));
  }, [init]);

  const loadUserInfo = async () => {
    await axios.get("api/mb/member/my-info").then((res) => {
      setUserInfo(res.data.data.member);
      console.log(res.data.data);
    });
  };

  useEffect(() => {
    loadUserInfo();
  }, []);

  useEffect(() => {
    console.log("userInfo", userInfo);
    if (userInfo && userInfo.email) {
      console.log("dd", userInfo.email.split("@")[1]);
      form.reset({
        no: userInfo.no,
        email: userInfo.email.split("@")[0],
        emailAddr: userInfo.email.split("@")[1],
        emailStr: userInfo.email.split("@")[1],
      });
    }
  }, [userInfo]);

  window.appBackKeyHandle = () => {
    if (open) {
      handleAlertClose();
    } else if (openComp) {
      setOpenComp(false);
      history.goBack();
    } else {
      history.goBack();
    }
  };

  return (
    <main id="main" className={"container"}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <div className="layout-flex">
          <FormProvider {...form}>
            <div className="layout-body">
              <Grid container spacing={1} className="form-group-wrap">
                <Grid item xs={12} md={6}>
                  <Email />
                </Grid>
              </Grid>
            </div>

            <div className="layout-footer">
              <div className="layout-link">
                <Box className="bottom-area">
                  <Grid container justifyContent="center" spacing={2}>
                    <Grid item>
                      <Button
                        className="btn-cancel"
                        variant="contained"
                        onClick={() => setOpen(true)}
                      >
                        취소
                      </Button>
                    </Grid>
                    <Grid item>
                      <Button color="primary" variant="contained" type="submit">
                        저장
                      </Button>
                    </Grid>
                  </Grid>
                </Box>
              </div>
            </div>
          </FormProvider>
        </div>
        <AlertConfirm
          open={open}
          handleAlertClose={handleAlertClose}
          text={"이메일 변경을 취소하시겠습니까?"}
          action={() => history.goBack()}
        />
        <DrawerComplete
          open={openComp}
          handleDrawerClose={() => {
            history.goBack();
          }}
          text={"이메일주소가 변경되었습니다."}
          callback={() => {}}
        />
        {/* <AlertComplete
          open={openComp}
          handleAlertClose={() => {
            setOpenComp(false);
          }}
          text="이메일주소가 변경되었습니다."
          action={() => history.push("/mypage/privacy")}
        /> */}
      </form>
    </main>
  );
}
